var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-item"},[_c('locale-router-link',{attrs:{"to":("/brands/" + (_vm.item.id))}},[_c('img',{staticClass:"brand-item__image",attrs:{"src":_vm.getImageUrl,"alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }